// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 전역 컨테이너 */
.superJackpot-container {
    /* padding: 0 16px; */
    /* width: 27rem; */
    box-sizing: border-box;
}

/* 상단 그리드 (items-end) */
.superJackpot-header-grid {
    display: flex;
    gap: 8px;
    align-items: end;
}

/* 입력 라인 그리드 (items-center + mt-4) */
.superJackpot-input-grid {
    display: flex;
    gap: 8px;
    align-items: end;
    margin-top: 16px;
    /* mt-4 */
}

/* 리스트 컨테이너 (mt-5, border, rounded, p-3) */
.superJackpot-list-container {
    margin-top: 24px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    padding: 12px;
    background-color: #ffffff;
    height: 248px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #9ca3af transparent;
}

.superJackpot-list-container::-webkit-scrollbar {
    width: 3px;
    /* 세로 스크롤 두께 */
}

.superJackpot-list-container::-webkit-scrollbar-thumb {
    background-color: #9ca3af;
    /* 스크롤 핸들 색 */
    border-radius: 4px;
}

.superJackpot-list-container::-webkit-scrollbar-thumb:hover {
    background-color: #6b7280;
    /* hover 시 색상 진하게 */
}

.superJackpot-list-container::-webkit-scrollbar-track {
    background: transparent;
    /* 스크롤 트랙(배경) 투명 */
}


/* 빈 리스트 메시지 */
.superJackpot-empty {
    color: #9ca3af;
    /* text-gray-400 */
}

/* 리스트 UL */
.superJackpot-list {
    list-style: none;
    margin: 0;
    padding: 0;
}

/* 리스트 LI (grid row) */
.superJackpot-list-item {
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    gap: 8px;
    align-items: center;
}

.superJackpot-list>li+li {
    margin-top: 12px;
}


/* 공통 컬럼 span */
.superJackpot-col-1 {
    grid-column: span 1 / span 1;
}

.superJackpot-col-2 {
    grid-column: span 2 / span 2;
}

.superJackpot-col-3 {
    grid-column: span 3 / span 3;
}

.superJackpot-col-4 {
    grid-column: span 4 / span 4;
}

.superJackpot-col-5 {
    grid-column: span 5 / span 5;
}

.superJackpot-col-6 {
    grid-column: span 6 / span 6;
}

.superJackpot-col-7 {
    grid-column: span 7 / span 7;
}

.superJackpot-col-8 {
    grid-column: span 8 / span 8;
}

.superJackpot-col-9 {
    grid-column: span 9 / span 9;
}

.superJackpot-col-10 {
    grid-column: span 10 / span 10;
}

.superJackpot-col-11 {
    grid-column: span 11 / span 11;
}

.superJackpot-col-12 {
    grid-column: span 12 / span 12;
}

/* 라벨 */
.superJackpot-form-label {
    display: block;
    font-size: 14px;
    /* text-sm */
    margin-bottom: 4px;
    /* mb-1 */
    color: #111827;
    /* gray-900 */
}

/* select, input 공통 */
.superJackpot-form-control {
    width: 100%;
    border: 1px solid #d1d5db;
    /* gray-300 */
    border-radius: 4px;
    /* rounded */
    padding: 8px;
    /* p-2 */
    background-color: #ffffff;
    box-sizing: border-box;
    outline: none;
    height: 35px;
}

.superJackpot-form-control:focus {
    border-color: #9ca3af;
    /* gray-400-ish */
}

/* 숫자 입력 우측 정렬 */
.superJackpot-text-right {
    text-align: right;
}

/* 박스(읽기 전용 표시용) */
.superJackpot-box {
    width: 100%;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    padding: 8px;
    background-color: #ffffff;
    box-sizing: border-box;
    height: 35px;
    display: flex;
    align-items: center;
    font-size: 14px;
}

.superJackpot-box-muted {
    background-color: #f9fafb;
    /* gray-50 */
}

/* 버튼 */
.superJackpot-btn {
    /* width: 100%; */
    width: 60px;
    min-width: 50px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    padding: 8px;
    cursor: pointer;
    background-color: rgba(237, 239, 241, 1);
    transition: background-color 0.15s ease-in-out;
    box-sizing: border-box;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.superJackpot-btn:hover {
    background-color: #f3f4f6;
    /* gray-100 */
}

/* 버튼 묶음 (flex + gap-2) */
.superJackpot-actions {
    display: flex;
    gap: 8px;
}

/* 도움말 */
.superJackpot-help {
    font-size: 12px;
    /* text-xs */
    color: #6b7280;
    /* text-gray-500 */
    margin-top: 16px;
    /* mt-4 */
    line-height: 1.5;
}

.btn-on {
    background-color: #003577;
    color: #fff
}

.btn-on:hover {
    background-color: #003577;
    color: #fff
}`, "",{"version":3,"sources":["webpack://./src/Pages/css/superJackpot.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;AACpB;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;AACb;;AAEA,0CAA0C;AAC1C;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;;AAGA,cAAc;AACd;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA,WAAW;AACX;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,iDAAiD;IACjD,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA,eAAe;AACf;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA,OAAO;AACP;IACI,cAAc;IACd,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,aAAa;AACjB;;AAEA,qBAAqB;AACrB;IACI,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA,gBAAgB;AAChB;IACI,iBAAiB;AACrB;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA,OAAO;AACP;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,wCAAwC;IACxC,8CAA8C;IAC9C,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA,QAAQ;AACR;IACI,eAAe;IACf,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ","sourcesContent":["/* 전역 컨테이너 */\r\n.superJackpot-container {\r\n    /* padding: 0 16px; */\r\n    /* width: 27rem; */\r\n    box-sizing: border-box;\r\n}\r\n\r\n/* 상단 그리드 (items-end) */\r\n.superJackpot-header-grid {\r\n    display: flex;\r\n    gap: 8px;\r\n    align-items: end;\r\n}\r\n\r\n/* 입력 라인 그리드 (items-center + mt-4) */\r\n.superJackpot-input-grid {\r\n    display: flex;\r\n    gap: 8px;\r\n    align-items: end;\r\n    margin-top: 16px;\r\n    /* mt-4 */\r\n}\r\n\r\n/* 리스트 컨테이너 (mt-5, border, rounded, p-3) */\r\n.superJackpot-list-container {\r\n    margin-top: 24px;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 4px;\r\n    padding: 12px;\r\n    background-color: #ffffff;\r\n    height: 248px;\r\n    overflow-y: auto;\r\n    scrollbar-width: thin;\r\n    scrollbar-color: #9ca3af transparent;\r\n}\r\n\r\n.superJackpot-list-container::-webkit-scrollbar {\r\n    width: 3px;\r\n    /* 세로 스크롤 두께 */\r\n}\r\n\r\n.superJackpot-list-container::-webkit-scrollbar-thumb {\r\n    background-color: #9ca3af;\r\n    /* 스크롤 핸들 색 */\r\n    border-radius: 4px;\r\n}\r\n\r\n.superJackpot-list-container::-webkit-scrollbar-thumb:hover {\r\n    background-color: #6b7280;\r\n    /* hover 시 색상 진하게 */\r\n}\r\n\r\n.superJackpot-list-container::-webkit-scrollbar-track {\r\n    background: transparent;\r\n    /* 스크롤 트랙(배경) 투명 */\r\n}\r\n\r\n\r\n/* 빈 리스트 메시지 */\r\n.superJackpot-empty {\r\n    color: #9ca3af;\r\n    /* text-gray-400 */\r\n}\r\n\r\n/* 리스트 UL */\r\n.superJackpot-list {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n/* 리스트 LI (grid row) */\r\n.superJackpot-list-item {\r\n    display: grid;\r\n    grid-template-columns: repeat(12, minmax(0, 1fr));\r\n    gap: 8px;\r\n    align-items: center;\r\n}\r\n\r\n.superJackpot-list>li+li {\r\n    margin-top: 12px;\r\n}\r\n\r\n\r\n/* 공통 컬럼 span */\r\n.superJackpot-col-1 {\r\n    grid-column: span 1 / span 1;\r\n}\r\n\r\n.superJackpot-col-2 {\r\n    grid-column: span 2 / span 2;\r\n}\r\n\r\n.superJackpot-col-3 {\r\n    grid-column: span 3 / span 3;\r\n}\r\n\r\n.superJackpot-col-4 {\r\n    grid-column: span 4 / span 4;\r\n}\r\n\r\n.superJackpot-col-5 {\r\n    grid-column: span 5 / span 5;\r\n}\r\n\r\n.superJackpot-col-6 {\r\n    grid-column: span 6 / span 6;\r\n}\r\n\r\n.superJackpot-col-7 {\r\n    grid-column: span 7 / span 7;\r\n}\r\n\r\n.superJackpot-col-8 {\r\n    grid-column: span 8 / span 8;\r\n}\r\n\r\n.superJackpot-col-9 {\r\n    grid-column: span 9 / span 9;\r\n}\r\n\r\n.superJackpot-col-10 {\r\n    grid-column: span 10 / span 10;\r\n}\r\n\r\n.superJackpot-col-11 {\r\n    grid-column: span 11 / span 11;\r\n}\r\n\r\n.superJackpot-col-12 {\r\n    grid-column: span 12 / span 12;\r\n}\r\n\r\n/* 라벨 */\r\n.superJackpot-form-label {\r\n    display: block;\r\n    font-size: 14px;\r\n    /* text-sm */\r\n    margin-bottom: 4px;\r\n    /* mb-1 */\r\n    color: #111827;\r\n    /* gray-900 */\r\n}\r\n\r\n/* select, input 공통 */\r\n.superJackpot-form-control {\r\n    width: 100%;\r\n    border: 1px solid #d1d5db;\r\n    /* gray-300 */\r\n    border-radius: 4px;\r\n    /* rounded */\r\n    padding: 8px;\r\n    /* p-2 */\r\n    background-color: #ffffff;\r\n    box-sizing: border-box;\r\n    outline: none;\r\n    height: 35px;\r\n}\r\n\r\n.superJackpot-form-control:focus {\r\n    border-color: #9ca3af;\r\n    /* gray-400-ish */\r\n}\r\n\r\n/* 숫자 입력 우측 정렬 */\r\n.superJackpot-text-right {\r\n    text-align: right;\r\n}\r\n\r\n/* 박스(읽기 전용 표시용) */\r\n.superJackpot-box {\r\n    width: 100%;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 4px;\r\n    padding: 8px;\r\n    background-color: #ffffff;\r\n    box-sizing: border-box;\r\n    height: 35px;\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 14px;\r\n}\r\n\r\n.superJackpot-box-muted {\r\n    background-color: #f9fafb;\r\n    /* gray-50 */\r\n}\r\n\r\n/* 버튼 */\r\n.superJackpot-btn {\r\n    /* width: 100%; */\r\n    width: 60px;\r\n    min-width: 50px;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 4px;\r\n    padding: 8px;\r\n    cursor: pointer;\r\n    background-color: rgba(237, 239, 241, 1);\r\n    transition: background-color 0.15s ease-in-out;\r\n    box-sizing: border-box;\r\n    height: 35px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.superJackpot-btn:hover {\r\n    background-color: #f3f4f6;\r\n    /* gray-100 */\r\n}\r\n\r\n/* 버튼 묶음 (flex + gap-2) */\r\n.superJackpot-actions {\r\n    display: flex;\r\n    gap: 8px;\r\n}\r\n\r\n/* 도움말 */\r\n.superJackpot-help {\r\n    font-size: 12px;\r\n    /* text-xs */\r\n    color: #6b7280;\r\n    /* text-gray-500 */\r\n    margin-top: 16px;\r\n    /* mt-4 */\r\n    line-height: 1.5;\r\n}\r\n\r\n.btn-on {\r\n    background-color: #003577;\r\n    color: #fff\r\n}\r\n\r\n.btn-on:hover {\r\n    background-color: #003577;\r\n    color: #fff\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
